export default __webpack_public_path__ + "static/media/500.308c48a0.png";